<script>
    import { appProfileState } from "../../state/ApplicationState.svelte";
    import { Loader } from "../../../../../SharedSvelte/GlobalLoader.svelte";
    import { baseUrl } from "../../../../../SharedSvelte/Common.svelte";
    import DependentCard from "./DependentCard.svelte";
    import DependentEditor from "./DependentEditor.svelte";
    
    let apiPromise = $state(fetchProfileDependentsContent()); 

    function onEditHandler(data){
        let workingDependent = appProfileState.dependentDetails.find(d => d.memberId === data.memberId);
        if (workingDependent){
            appProfileState.workingDependent = workingDependent;
            appProfileState.showDependentEditor = true;
            window.scrollTo(0, 0);
        }
    }

    async function fetchProfileDependentsContent() {
        Loader.display();
        
        try {
            const response = await fetch(`${baseUrl}Options/Profile/ProfileDependentsContent`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    '__RequestVerificationToken': document.getElementsByName("__RequestVerificationToken")[0].value
                },
                // body: JSON.stringify({
                //     id
                // })
            });

            appProfileState.showDependentEditor = false;
            appProfileState.workingDependent = null;
            window.scrollTo(0, 0);

            if (!response.ok) {
                const error = `Server exception: ${response.status} ${response.statusText}`;
                //prompt.showMessage(error, "Information");
                throw new Error(error);
            }

            const data = await response.json();
            appProfileState.dependentDetails = data.dependentDetails;
            appProfileState.canAccessEnrollment = data.canAccessEnrollment;
            //appProfileState.relationshipTypes = data.relationshipTypes;
            //appProfileState.genderTypes = data.genderTypes;
            //appProfileState.sexAtBirthTypes = data.sexAtBirthTypes;

            return data; // Resolves the Promise with the fetched data
        } catch (error) {
            console.error("Error fetching profile dependent content:", error);
            return Promise.reject(error); // Rejects the Promise with the error
        } finally {
            Loader.hide();
        }
    }
    
</script>

{#if appProfileState.showDependentEditor }
    <DependentEditor />
{:else}
    <main>
        <h1 class="mt-3 mb-3 ms-3">Dependents</h1>
        {#await apiPromise}
            <div>Loading...</div>
        {:then data}
            <!-- <pre>{JSON.stringify(data)}</pre> -->
       
            <div class="row">
                <div class="col">
                    <div class="alert alert-info mt-3 mb-4">
                        {#if !appProfileState.dependentDetails || appProfileState.dependentDetails.length <= 0}
                            <p>There are no dependents in this subscription.</p>
                        {/if}
                        If you have had a recent life changing event (birth, adoption, etc.) you can add dependents by
                        {#if appProfileState.canAccessEnrollment}
                            <a href="{baseUrl}Home/Open?module=Enrollment" class="alert-link"> updating your enrollment.</a>
                        {:else}
                            <span> updating your enrollment.</span>  
                        {/if}
                    </div>
                </div>
            </div>
            <div class="row">
                {#each appProfileState.dependentDetails as dependent}
                    <div class="mb-3 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <DependentCard 
                            relationship={dependent.relationship}
                            fullName={dependent.fullName}
                            memberId={dependent.memberId}
                            residentialAddress1={dependent.residentialAddress1}
                            residentialAddress2={dependent.residentialAddress2}
                            residentialCity={dependent.residentialCity}
                            residentialState={dependent.residentialState}
                            residentialZip={dependent.residentialZip}
                            mailingAddress1={dependent.mailingAddress1}
                            mailingAddress2={dependent.mailingAddress2}
                            mailingCity={dependent.mailingCity}
                            mailingState={dependent.mailingState}
                            mailingZip={dependent.mailingZip}
                            dateOfBirth={dependent.dateOfBirth}
                            homePhone={dependent.homePhone}
                            cellPhone={dependent.cellPhone}
                            email={dependent.email}
                            isPhiRestricted={dependent.isPHIRestricted}
                            hasPendingChanges={dependent.hasPendingChanges}
                            oneditcallback={onEditHandler}
                        />
                    </div>
                {/each}
            </div>
            
    
        <!-- {:catch error}
            <div class="text-danger">{error}</div> -->
        {/await}
        
    </main>
{/if}
